import { ActionsUnion, createAction } from '@housinganywhere/safe-redux';
import { Thunk } from 'ha/myredux/types';
import { GlobalState } from 'ha/types/store';
import reportError from 'ha/helpers/bugsnag/reportError';
import { BillingSubscriptionProduct } from 'ha/services/apiV2/types/Subscriptions';

export enum ActionTypes {
  START = '[BillingSubscriptionLanding] LOAD_PRODUCT',
  DONE = '[BillingSubscriptionLanding] LOAD_PRODUCT_DONE',
  FAIL = '[BillingSubscriptionLanding] LOAD_PRODUCT_FAIL',
}

export const Actions = {
  start: () => createAction(ActionTypes.START),
  done: (product: BillingSubscriptionProduct) =>
    createAction(ActionTypes.DONE, product),
  fail: () => createAction(ActionTypes.FAIL),
};

export type ActionsType = ActionsUnion<typeof Actions>;

type LoadProduct = () => Thunk<GlobalState>;

const loadProduct: LoadProduct =
  () =>
  async (dispatch, _, { apiV2 }) => {
    dispatch(Actions.start());

    return apiV2
      .getSubscriptionTenantProducts()
      .then(res => {
        dispatch(Actions.done(res.data));
      })
      .catch(err => {
        reportError('request loadProduct failed', { metaData: err });

        return dispatch(Actions.fail());
      });
  };

export default loadProduct;
